import { fortifySoftwareSecurityCenter } from "../fortifySoftwareSecurityCenter/manifest";
import { fortifyWebInspect } from "../fortifyWebInspect/manifest";
import { defineProduct } from "../types";
import logo from "./logo.svg";
export const fortify = defineProduct({
  name: "Fortify",
  tagLine: "Application security",
  logo,
  tags: ["security"],
  variants: [fortifySoftwareSecurityCenter, fortifyWebInspect],
});
